export const WorkExperience = () => (
  <div className="tab-pane-container">
    <div className="container">
      <div className="timeline-block timeline-block-right">
        <div className="marker" />
        <div className="timeline-content">
          <h3>Software Engineer</h3>
          <span>
            <b>Organization:</b> Zeus Learning
          </span>
          <span>
            <b>Location:</b> Mumbai, India
          </span>
          <span>
            <b>Full Time:</b> July 2023 - October 2025
          </span>
          <span>
            <b>Experience:</b> 2 Years 3 Months
          </span>

          <p className="work-section-title">
            <strong>Annotate.net</strong> (Browser Extension &amp; Web Platform)
          </p>
          <ul className="work-experience-list">
            <li>
              Built and enhanced features for an interactive annotation and
              discussion tool used in live classes.
            </li>
            <li>
              Designed and implemented Discussion Board with real-time updates,
              drag-and-drop organization, publish/unpublish controls, and
              delete/restore functionality.
            </li>
            <li>
              Added media restoration for deleted assets, including uploaded
              files, YouTube videos, voice/screen recordings in Browser
              Extension.
            </li>
            <li>
              Improved accessibility to WCAG AA across the platform for
              inclusive use.
            </li>
            <li>
              Used Playwright to add automation scripts for end-to-end testing.
            </li>
          </ul>

          <p className="work-section-title">
            <strong>IL Math Games</strong>
          </p>
          <ul className="work-experience-list">
            <li>
              Developing interactive math games with built-in accessibility
              features aligned with WCAG AA, using React Redux.
            </li>
          </ul>

          <span>
            <b>Technologies:</b> React JS, C#, PHP, JavaScript, MySQL, Playwright
          </span>
        </div>
      </div>

      <div className="timeline-block timeline-block-left">
        <div className="marker" />
        <div className="timeline-content">
          <h3>AI Intern</h3>
          <span>
            <b>Organization:</b> Lab Systems
          </span>
          <span>
            <b>Location:</b> Mumbai, India
          </span>
          <span>
            <b>Internship:</b> February 2023 — July 2023
          </span>
          <span>
            <b>Experience:</b> 6 Months
          </span>

          <ul className="work-experience-list">
            <li>
              Designed and implemented advanced Python applications to extract
              location data from image metadata, seamlessly integrating with
              Google Maps for enhanced visualization.
            </li>
            <li>
              Developed robust algorithms for precise extraction of images from
              diverse document file formats, including PDF, PPTX, PPT, DOC, and
              DOCX, leveraging various Python libraries.
            </li>
            <li>
              Developed a cutting-edge product utilizing pre-trained Convolutional
              Recurrent Neural Networks (CRNN) from keras-ocr and Optical
              Character Recognition (OCR) techniques to accurately detect vehicle
              number plates and extract numbers from images, achieving high
              accuracy even in challenging conditions.
            </li>
          </ul>

          <span>
            <b>Technologies:</b> Python, TensorFlow, Keras, keras-ocr, OCR,
            Google Maps API, document processing libraries
          </span>
        </div>
      </div>

      <div className="timeline-block timeline-block-right">
        <div className="marker" />
        <div className="timeline-content">
          <h3>Machine Learning Intern</h3>
          <span>
            <b>Organization:</b> Suvidha Foundation - Mahila Mandal (NGO)
          </span>
          <span>
            <b>Location:</b> Remote, India
          </span>
          <span>
            <b>Internship:</b> December 2021 - January 2022
          </span>
          <span>
            <b>Experience:</b> 1 Month
          </span>

          <ul className="work-experience-list">
            <li>
              Contributed to research projects at Suvidha Foundation, an NGO, as
              part of the Code Karo Yaaro initiative. Surveyed over 100 research
              papers and extracted information on text summarization.
            </li>
            <li>
              Engineered an extractive text summarizer for English using Flask,
              NLTK, and Sumy, with a GUI built in HTML, CSS, and Bootstrap 5,
              hosted on Heroku.
            </li>
          </ul>

          <span>
            <b>Technologies:</b> Python, Flask, NLTK, Sumy, HTML, CSS, Bootstrap 5,
            Heroku
          </span>
        </div>
      </div>

      <div className="timeline-block timeline-block-left">
        <div className="marker" />
        <div className="timeline-content">
          <h3>IT Intern </h3>
          <span>
            <b>Organization:</b> Saiva Systems - CMMI Level III certified company
          </span>
          <span>
            <b>Location:</b> Noida, Uttar Pradesh, India
          </span>
          <span>
            <b>Internship:</b> July 2021 - August 2021
          </span>
          <span>
            <b>Experience:</b> 1 Month
          </span>

          <ul className="work-experience-list">
            <li>
              Engineered an applicant tracking system to efficiently batch
              process over 100 resumes using regular expressions (Regex) with
              support for .doc/.docx resume formats, expanding compatibility and
              usability.
            </li>
            <li>
              Developed a converter to automatically convert .doc/.docx files into
              .pdf format during scanning, streamlining the document management
              process.
            </li>
            <li>
              Implemented a search keyword feature, allowing users to customize
              and improve search efficiency.
            </li>
          </ul>

          <span>
            <b>Technologies:</b> Regex, .doc/.docx and PDF processing, search
            and batch automation
          </span>
        </div>
      </div>

      <div className="timeline-block timeline-block-right">
        <div className="marker" />
        <div className="timeline-content">
          <h3>Web Developer</h3>
          <span>
            <b>Organization:</b> E-Cell SLRTCE
          </span>
          <span>
            <b>Location:</b> Mumbai, India
          </span>
          <span>
            <b>Role period:</b> August 2020 - May 2021
          </span>
          <span>
            <b>Experience:</b> 10 Months
          </span>

          <ul className="work-experience-list">
            <li>
              Developed the homepage and Teams section using HTML, Sass, and
              JavaScript. Collaborated with a team using Git and GitHub for
              version control.
            </li>
          </ul>

          <span>
            <b>Technologies:</b> HTML, Sass, JavaScript, Git, GitHub
          </span>
        </div>
      </div>
    </div>
  </div>
);
